import { PayloadAction } from '@reduxjs/toolkit';
import { call, put } from 'redux-saga/effects';

import { DisposalInsights } from '@agency/apis/disposals';
import { $httpRootApi } from '@core/http-client';
import { disposalManageInsightsActions } from '@redux/reducers/disposals/disposalInsights/disposalInsightsReducer';
import { getDefaultError } from '@shared/utils/common';

export function* getDisposalManageInsightsData(action: PayloadAction<Id>) {
  yield put(disposalManageInsightsActions.setLoading(true));

  try {
    const { data } = yield call(() => $httpRootApi.get<DisposalInsights>(`/disposals/${action.payload}/insights`));

    yield put(disposalManageInsightsActions.getDataSuccess(data));
  } catch (e) {
    yield put(disposalManageInsightsActions.getDataFailure(getDefaultError(e?.response?.data?.message)));
  }
}
